import { Injectable } from '@angular/core';
import { initializeApp, getApps, getApp } from 'firebase/app';
import {
  getFirestore,
  collection,
  addDoc,
  query,
  where,
  orderBy,
  limit,
  onSnapshot,
  doc,
  deleteDoc,
  updateDoc,
  serverTimestamp,
  getDocs,
  writeBatch,
  setDoc,
  DocumentData,
} from 'firebase/firestore';
// import {
//   getDatabase,
//   ref,
//   onDisconnect,
//   set,
//   onValue,
//   serverTimestamp as rtdbTimestamp,
// } from 'firebase/database';
import { getMessaging, getToken, Messaging, onMessage } from 'firebase/messaging';
import { getAuth,signInWithCustomToken } from 'firebase/auth';
import { environment } from '../../../environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChatServiceService {
  app;
  db;
  // rtdb;
  messaging:any;
  auth:any;
  private unreadMessagesSource = new BehaviorSubject<number>(0);
  totalUnreadMessages$ = this.unreadMessagesSource.asObservable();

  constructor() {
    const chatAppName = 'chatApp';

    if (!getApps().some((app) => app.name === chatAppName)) {
      this.app = initializeApp(environment.firebaseConfigForChat, chatAppName);
    } else {
      this.app = getApp(chatAppName);
    }

    this.db = getFirestore(this.app);
    // this.rtdb = getDatabase(this.app);
    // this.messaging = getMessaging(this.app);
    // this.auth = getAuth(this.app);

    // Auth disabled for chat: rely on app user IDs for presence via RTDB only.
    // Use setPresenceForAppUser(appUserId) from the component after you know the app user.
  }
   async loginWithToken(token: string) {
    try {
      // Sign in anonymously
      this.auth = this.getAuthInstance();
      await signInWithCustomToken(this.auth, token);
    } catch (error) {
      console.error('Error signing in anonymously:', error);
    }
  }

  // ------------------- PRESENCE -------------------

  // Listen to a user’s online/offline status (RTDB)


  // Optionally mirror app userId to auth uid (if needed for presence)
  // Call this right after you obtain/know your app userId
  
  async setUserOnline(userId: string) {
  const userRef = doc(this.db, `users/${userId}`);
  console.log(`Setting user ${userId} online.`);

  await setDoc(userRef, {
    online: true,
    lastSeen: serverTimestamp()
  }, { merge: true }); // merge keeps old fields if doc exists
}

async setUserOffline(userId: string) {
  const userRef = doc(this.db, `users/${userId}`);
  console.log(`Setting user ${userId} offline.`);

  await setDoc(userRef, {
    online: false,
    lastSeen: serverTimestamp()
  }, { merge: true });
}

  // ------------------- MESSAGES -------------------
  async sendMessage(chatId: string, messageData: any) {
    const messagesRef = collection(this.db, `chats/${chatId}/messages`);
    const received = await addDoc(messagesRef, messageData);
    return received;
  }

  /* listenMessages(chatId: string, callback: (messages: any[]) => void) {
    const messagesRef = collection(this.db, `chats/${chatId}/messages`);
    const messagesQuery = query(messagesRef, orderBy('createdAt', 'asc'));

    return onSnapshot(messagesQuery, (snapshot) => {
      const msgs = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      
      callback(msgs);
    });
  } */
  listenMessages(
    chatId: string,
    currentUserId: string,
    callback: (messages: any[], unreadCount: number) => void
  ) {
    const messagesRef = collection(this.db, `chats/${chatId}/messages`);
    const messagesQuery = query(messagesRef, orderBy('createdAt', 'asc'));

    return onSnapshot(messagesQuery, (snapshot) => {
      const msgs = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // Count unseen messages not from current user
      const unreadCount = msgs.filter(
        (msg: any) => !msg.seen && msg.senderId !== currentUserId
      ).length;

      callback(msgs, unreadCount);
    });
  }

  private getMessagingInstance() {
    this.messaging = this.getMessagingInstance();
  if (!this.messaging) {
    this.messaging = getMessaging(this.app);
  }
  return this.messaging;
}

private getAuthInstance() {
  if (!this.auth) {
    this.auth = getAuth(this.app);
  }
  return this.auth;
}

  

async markMessagesAsSeen(chatId: string, currentUserId: string) {
  const messagesRef = collection(this.db, `chats/${chatId}/messages`);
 
  // Only messages FROM John (otherUserId) TO me (currentUserId)
  const q = query(
    messagesRef,
    // where('senderId', '==', otherUserId),
    where('receiverId', '==', String(currentUserId)),
    where('seen', '==', false)
  );

  const snapshot = await getDocs(q);
  if (snapshot.empty) {
    console.log("No unseen messages found for this chat.");
    return;
  }

  const batch = writeBatch(this.db);
  snapshot.forEach((docSnap) => {
    batch.update(docSnap.ref, { seen: true, seenAt: serverTimestamp() });
  });
  await batch.commit();


}



  // ------------------- UNREAD COUNT -------------------
  listenUnreadCount(
    chatId: string,
    currentUserId: string,
    callback: (count: number) => void
  ) {
    const messagesRef = collection(this.db, `chats/${chatId}/messages`);
    const q = query(messagesRef, where('seen', '==', false));
    return onSnapshot(q, (snapshot) => {
      let count = 0;
      snapshot.forEach((docSnap) => {
        const data = docSnap.data() as any;
        if (data.senderId !== currentUserId) count++;
      });
      callback(count);
    });
  }

  // Latest message per chat
  listenLatestMessage(chatId: string, callback: (last: any | null) => void) {
    const messagesRef = collection(this.db, `chats/${chatId}/messages`);
    const q = query(messagesRef, orderBy('createdAt', 'desc'), limit(1));
    return onSnapshot(q, (snapshot) => {
      if (snapshot.empty) return callback(null);
      const d = snapshot.docs[0];
      callback({ id: d.id, ...d.data() });
    });
  }

  // ------------------- PUSH NOTIFICATIONS -------------------
  requestFcmToken() {
    this.messaging = this.getMessagingInstance();
    console.log('Requesting FCM token...');
    return getToken(this.messaging, {
      vapidKey: environment.firebaseConfigForChat.vapidKey,
    });
  }

  listenPushNotifications(callback: Function) {
    this.messaging = this.getMessagingInstance();
    onMessage(this.messaging, (payload) => {
      console.log('Received push notification:', payload);
      callback(payload);
    });
  }

  // ------------------- MESSAGE MANAGEMENT -------------------
  async deleteMessage(msg: any) {
    if (confirm('Delete this message?')) {
      await deleteDoc(doc(this.db, `chats/${msg.chatId}/messages/${msg.id}`));
    }
  }

  async editMessage(chatId: string, messageId: string, newData: any) {
    const cleanData: any = {};
    for (const key in newData) {
      if (newData[key] !== undefined) {
        cleanData[key] = newData[key];
      }
    }

    await updateDoc(doc(this.db, `chats/${chatId}/messages/${messageId}`), {
      ...cleanData,
      editedAt: serverTimestamp(),
    });
  }

  // ------------------- CLEAR ALL MESSAGES -------------------
  async clearAllMessages(chatId: string) {
    const ok = confirm('Clear all chat?');
    if (!ok) return;
    const messagesRef = collection(this.db, `chats/${chatId}/messages`);
    const snapshot = await getDocs(messagesRef);
    const deletes: Promise<void>[] = [];
    snapshot.forEach((d) => {
      deletes.push(
        deleteDoc(
          doc(this.db, `chats/${chatId}/messages/${d.id}`)
        ) as unknown as Promise<void>
      );
    });
    await Promise.all(deletes);
  }

// async listenUserStatus(
//   userId: string,
// ) {
//   const userRef = doc(this.db, `users/${'2233'}`);

//   return onSnapshot(userRef, (docSnap) => {
//     if (docSnap.exists()) {
//       const data = docSnap.data() as DocumentData;
//  console.log("User status updated:", data);
//     } else {
//       console.warn(`User ${userId} not found in Firestore`);
//     }
//   });
// }
async listenUserStatus(userId: string, callback: (status: any) => void) {
  const userRef = doc(this.db, `users/${userId}`);

  return onSnapshot(userRef, (docSnap) => {
    if (docSnap.exists()) {
      const data = docSnap.data() as any;
      callback({
        online: data.online,
        lastSeen: data['lastSeen']?.toDate?.() || null
      });
    } else {
      console.warn(`User ${userId} not found in Firestore`);
    }
  });
}
updateTotalUnread(count: number) {
    this.unreadMessagesSource.next(count);
  }
private readonly IV_LENGTH = 12;
// 🔑 Generate AES key from chatRoomId
  private async getChatKey(chatRoomId: string): Promise<CryptoKey> {
    const encoder = new TextEncoder();
    const keyBytes = encoder.encode(chatRoomId);

    const finalKey = new Uint8Array(32);
    for (let i = 0; i < finalKey.length; i++) {
      finalKey[i] = keyBytes[i % keyBytes.length];
    }

    return crypto.subtle.importKey(
      'raw',
      finalKey,
      { name: 'AES-GCM' },
      false,
      ['encrypt', 'decrypt']
    );
  }

  // 🔐 Encrypt message

async encryptMessage(
  plainText: string | null | undefined,
  imageUrl: string | null | undefined,
  chatRoomId: string
): Promise<{ message: string | null; imageUrl: string | null }> {

  const key = await this.getChatKey(chatRoomId);
  const encoder = new TextEncoder();

  const encryptValue = async (value: string | null | undefined) => {
    if (!value) return null;

    const iv = crypto.getRandomValues(new Uint8Array(this.IV_LENGTH));
    const encoded = encoder.encode(value);

    const encryptedBuffer = await crypto.subtle.encrypt(
      { name: 'AES-GCM', iv },
      key,
      encoded
    );

    const combined = new Uint8Array(iv.length + encryptedBuffer.byteLength);
    combined.set(iv, 0);
    combined.set(new Uint8Array(encryptedBuffer), iv.length);

    return btoa(String.fromCharCode(...combined));
  };

  return {
    message: await encryptValue(plainText),
    imageUrl: await encryptValue(imageUrl),
  };
}


  // async encryptMessage(
  //   plainText: string,
  //   imageUrl: string | null | undefined,
  //   chatRoomId: string
  // ): Promise<string> {

  //   const key = await this.getChatKey(chatRoomId);
  //   const iv = crypto.getRandomValues(new Uint8Array(this.IV_LENGTH));

  //   const encoder = new TextEncoder();
  //   const encodedText = encoder.encode(plainText);

  //   const encryptedBuffer = await crypto.subtle.encrypt(
  //     { name: 'AES-GCM', iv },
  //     key,
  //     encodedText
  //   );

  //   const combined = new Uint8Array(iv.length + encryptedBuffer.byteLength);
  //   combined.set(iv, 0);
  //   combined.set(new Uint8Array(encryptedBuffer), iv.length);

  //   return btoa(String.fromCharCode(...combined));
  // }

  // 🔓 Decrypt message
  // async decryptMessage(
  //   cipherText: string,
  //   chatRoomId: string
  // ): Promise<string> {

  //   const combined = Uint8Array.from(
  //     atob(cipherText),
  //     c => c.charCodeAt(0)
  //   );

  //   const iv = combined.slice(0, this.IV_LENGTH);
  //   const encrypted = combined.slice(this.IV_LENGTH);

  //   const key = await this.getChatKey(chatRoomId);

  //   const decryptedBuffer = await crypto.subtle.decrypt(
  //     { name: 'AES-GCM', iv },
  //     key,
  //     encrypted
  //   );

  //   const decoder = new TextDecoder();
  //   return decoder.decode(decryptedBuffer);
  // }
 async decryptMessage(
  cipherText: string | null | undefined,
  imageUrl: string | null | undefined,
  chatRoomId: string
): Promise<{ message: string; imageUrl: string | null }> {

  let decryptedMessage = '';
  let decryptedImageUrl: string | null = imageUrl ?? null;

  try {
    // 🔐 Decrypt text message
    if (cipherText) {
      const combined = Uint8Array.from(
        atob(cipherText),
        c => c.charCodeAt(0)
      );

      const iv = combined.slice(0, this.IV_LENGTH);
      const encrypted = combined.slice(this.IV_LENGTH);

      const key = await this.getChatKey(chatRoomId);

      const decryptedBuffer = await crypto.subtle.decrypt(
        { name: 'AES-GCM', iv },
        key,
        encrypted
      );

      decryptedMessage = new TextDecoder().decode(decryptedBuffer);
    }

    // 🔐 Decrypt image URL (if encrypted)
    if (imageUrl) {
      const combinedImg = Uint8Array.from(
        atob(imageUrl),
        c => c.charCodeAt(0)
      );

      const ivImg = combinedImg.slice(0, this.IV_LENGTH);
      const encryptedImg = combinedImg.slice(this.IV_LENGTH);

      const key = await this.getChatKey(chatRoomId);

      const decryptedImgBuffer = await crypto.subtle.decrypt(
        { name: 'AES-GCM', iv: ivImg },
        key,
        encryptedImg
      );

      decryptedImageUrl = new TextDecoder().decode(decryptedImgBuffer);
    }

  } catch (err) {
    console.warn('Decryption failed, returning original values', err);
    decryptedMessage = cipherText ?? '';
    decryptedImageUrl = imageUrl ?? null;
  }

  return {
    message: decryptedMessage,
    imageUrl: decryptedImageUrl
  };
}


 

}
